export const TIMER_MEDIA_OBJECT_FIT = {
  COVER: 'object-cover',
  CONTAIN: 'object-contain',
};

export const getTimerMediaObjectFitClass = ({ width, height } = {}) => {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return TIMER_MEDIA_OBJECT_FIT.COVER;
  }

  return width > height
    ? TIMER_MEDIA_OBJECT_FIT.CONTAIN
    : TIMER_MEDIA_OBJECT_FIT.COVER;
};
